import * as React from 'react'
import { batch } from '@preact/signals-react';
import {Box, Typography} from "@mui/material";
import {IconSeeker} from "@ui-seeker/core";
import { formatDate, FORMAT_DATE_BACK } from "@ui-seeker/utils";

import {ImageSkuBlock, SkuInfoBlock} from "@components";
import {DATE_PERIODS, ACTUAL_PERIODS} from '@constants';
import { useBuildExternalURL } from "@hooks"
import { useMarketplacesLostBuyBoxShowEvolution } from '../@hooks';


export default function skuColumn() {
	return [{
        name: 'category', label: 'Category',
        options: {
            display: 'excluded'
        }
    },{
        name: 'brand', label: 'Brand',
        options: {
            display: 'excluded'
        }
    },{
		name:'ean', label: 'EAN',
		options: {
			display: 'excluded',
			filterType: 'textField'
		}
	},{
		name: 'skuName', label: 'Product Name',
		options: {
			filterType: 'textField',
			setCellHeaderProps: () => ({ sx: { minWidth: 200 }}),
			customBodyRowRenderLite: (value, row) => {
				const { category, brand, ean, siteID, productID, date, skuID, reference } = row
				const { productURL } = useBuildExternalURL({ siteData: { siteID, productID } })

				return <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: 2 }}>
					<Box>
						<ImageSkuBlock
							productID={productID}
							date={date}
							siteID={siteID}
							skuID={skuID}
							skuName={row.skuName}
						/>
					</Box>
					<Box>
						<SkuInfoBlock
							sku={value}
							category={category}
							brand={brand}
							ean={ean}
							reference={reference}
							productURL={productURL}
						/>
						<Typography variant="caption" sx={{display: 'block', color: "text.disabled"}}>
							ASIN: {productID}
						</Typography>
						<ShowBuyBoxEvolutionCell 
							productID={productID} 
							skuID={skuID} 
							siteID={siteID}
						/>
					</Box>
				</Box>
			}
		}
	}]
}

const ShowBuyBoxEvolutionCell = ({productID, skuID, siteID}) => {
	const { handleClickShowEvolution, isOpenEvolutionChart } = useMarketplacesLostBuyBoxShowEvolution(productID, skuID, siteID)

	const isOpenChartClass = isOpenEvolutionChart ? 'is-open' : ''
    return <Box data-tour-trigger className={`${isOpenChartClass}`} sx={{ display: 'flex', alignItems: 'flex-end'}} onClick={handleClickShowEvolution}  >
        <Typography variant="caption" sx={{ display: 'block', color: "text.primary", mt: 1, mr: 0.5, cursor: 'pointer', "&:hover":{ textDecoration: 'underline'} }}>
            Show Buy Box Evolution
        </Typography>
        <IconSeeker icon={'chart-line'} sx={{ mr: 0.5, margin: .5, color: 'primary.main'}}/>
    </Box>

}